import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import OstorlabConfigListing from "./OstorlabConfigListing";
import OstorlabCredentialsForm from "./OstorlabCredentialsForm";

export default function OstorlabPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={OstorlabCredentialsForm}
      PullConfigListingView={OstorlabConfigListing}
    />
  );
}